import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Countdown } from './Countdown';
import TimerIcon from '@mui/icons-material/Timer';
export function UrgencySection() {
  return <SectionWrapper className="bg-red-50 py-12 border-y border-red-100" data-id="element-275">
      <div className="max-w-2xl mx-auto text-center" data-id="element-276">
        <div className="inline-flex items-center justify-center text-red-600 mb-4" data-id="element-277">
          <TimerIcon fontSize="large" className="mr-2" data-id="element-278" />
          <h2 className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-279">
            Precio de Lanzamiento — Cierra en:
          </h2>
        </div>

        <div className="mb-6" data-id="element-280">
          <Countdown data-id="element-281" />
        </div>

        <p className="text-red-600 font-bold mb-8 flex items-center justify-center" data-id="element-282">
          <span className="mr-2" data-id="element-283">⚠️</span> Después sube $8.000. No vuelve al
          precio actual.
        </p>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-red-100" data-id="element-284">
          <div className="flex justify-between items-end mb-2" data-id="element-285">
            <span className="font-bold text-gray-800 flex items-center" data-id="element-286">
              <span className="w-3 h-3 rounded-full bg-red-500 mr-2 animate-pulse" data-id="element-287"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-sm font-bold text-red-600 bg-red-100 px-2 py-1 rounded" data-id="element-288">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-4 mb-2 overflow-hidden" data-id="element-289">
            <div className="bg-red-500 h-4 rounded-full" style={{
            width: '68%'
          }} data-id="element-290"></div>
          </div>
          <p className="text-right text-xs text-gray-500 font-medium" data-id="element-291">
            68% de los cupos ya tomados
          </p>
        </div>
      </div>
    </SectionWrapper>;
}